
<template>
  <div data-app="true" class="v-application v-application--is-ltr"  id="app">
    <Menu ref="nav" :mini="mini" @drawerChange="navToggle" style="height: 100vh;z-index:99;position:fixed; transition: all 250ms linear 0.2s;"/>
      <v-container :class="mini ? 'miniClose px-0 py-0' : 'miniOpen px-0 py-0'" fluid style="transition: all 250ms linear 0.2s;">
        <v-row class="mx-0 my-0">
          <v-slide-x-transition mode="out-in" duration="400">
            <div class="snap-content">
              <header-block></header-block>
              <main id="page-wrap" ref="pageWrap">
                <div class="js-main-content dummy" style="background:#f9f9f9">
                  <router-view />
                </div>
              </main>
            </div>
          </v-slide-x-transition>
        </v-row>
      </v-container>
  </div>
</template>
<style src="./styles/styles.scss" lang="scss"></style>

<script>
/* eslint-disable */
// eslint-disable-next-line
import '@mdi/font/css/materialdesignicons.css'
import Menu from "@/components/core/Menu";
import HeaderBlock from "@/components/core/Header";

export default {
  components: {
    HeaderBlock,
    Menu
  },
  data() {
    return {
      mini: this.$vuetify.breakpoint.mdAndUp ? false : true
    };
  },
  methods: {
    navToggle (val) {
      this.mini = val;
    }
  }
};
</script>
<style scoped lang="scss">
#app{
  height: inherit;
  .miniClose{
    position: absolute;
    right:0;
    max-width: calc(100% - 56px);
  }
  .snap-content{
    width:100%;
  }
}
@media(min-width:560px){
  .miniOpen{
    position: absolute;
    right:0;
    max-width: calc(100% - 180px);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue